<template>
    <div :style="`--headerHeight: ${headerHeight}px;`" class="c-product-info-container">
        <div class="c-product-info-container__content c-product-info-container__content--mobile-padding">
            <div class="o-row-full">
                <div class="o-extra-small--12 o-medium--8 o-medium--offset-2">
                    <slot></slot>
                </div>
            </div>
        </div>
        <div class="c-product-info-container__content">
            <div class="o-row-full">
                <div class="o-extra-small--12 o-medium--8 o-medium--offset-2">
                    <slot name="noPaddingOnMobile"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { HEADER_MODULE_NAME } from '~coreModules/header/js/header-store';

export default {
    name: 'ProductInfoContainer',
    computed: {
        ...mapState(HEADER_MODULE_NAME, {
            headerHeight: state => state.headerHeight,
        }),
    },
};
</script>

<style lang="scss">
    .c-product-info-container {
        margin-top: 0;
        top: 0;

        @include breakpoint(large) {
            position: -webkit-sticky;
            position: sticky;
            top: calc(20px + var(--headerHeight));
            margin: $nu-spacer-6 0 0;
            padding: 0;
        }

        &__content {
            &--mobile-padding {
                padding: 0 $nu-spacer-2;

                @include breakpoint(small) {
                    padding: 0 $nu-spacer-8;
                }
            }

            @include breakpoint(medium) {
                margin: $nu-spacer-1 0 0;
                padding: 0 $nu-spacer-8;
            }

            @include breakpoint(large) {
                padding: 0;
            }
        }
    }
</style>
